// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JIo8s","label":"styles_label__QNd3L","required":"styles_required__tDm8X","char-counter":"styles_char-counter__2GACX"};